import PropTypes from 'prop-types';
import React from 'react';

function Callout({children, brackets, href}) {
  if (href) {
    children = <a href={href} className='blue'>{children}</a>;
  }

  return <span>
    {brackets ? <span>&lt;</span> : null}
    <span className='blue'>{children}</span>
    {brackets ? <span>&gt;</span> : null}
  </span>;
}
Callout.propTypes = {
  brackets: PropTypes.bool,
  children: PropTypes.any,
  href: PropTypes.string,
};
Callout.defaultProps = {
  brackets: false,
};

export default Callout;
